import { render, staticRenderFns } from "./PurchaseTemplateEdit.vue?vue&type=template&id=09098410&"
import script from "./PurchaseTemplateEdit.vue?vue&type=script&lang=js&"
export * from "./PurchaseTemplateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports